<template>
  <div class="new-home-con">
    <!-- <el-carousel arrow="never" :interval="10000">
      <el-carousel-item
        v-for="(item, index) in carouselList"
        :key="index"
        :style="{ backgroundImage: 'url(' + item.img + ')' }"
      >
      </el-carousel-item>
     
    </el-carousel> -->
    <div class="el-carousel__item " :class="this.$route.name=='newsIndex'?'u070db_3':'u070db_4'">
 
    </div>
    <div class="new-home-wrap">
      <Header></Header>
      <div class="new-home-search">
        <SearchCon></SearchCon>
        <div class="new-home-search-text" v-if="this.$route.name=='newsIndex'">
          Uncover the strategic insights behind every company headline
        </div>
         <div class="new-home-search-text" v-else>
     Navigate international trade with confidence by screening companies and products against global sanctions
        </div>
      </div>
      <!-- 底部 -->
      <div class="new-home-bottom">
        <div class="new-home-title">Bringing Global Business Into Focus</div>
        <div class="new-home-bottom-card">
          <div class="new-home-card-left" :class="this.$route.name=='newsIndex'?'NewsBack':'RiskBack'">
            <img :src="ellipseImg" />
            <div
              class="slider-box"
              @click="goPage('https://www.csibizinfo.com/?Form=Csi')"
            >
              <div class="slider-con">
                <div
                  class="slider-item"
                  v-for="(item, index) in textList"
                  :key="index"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="new-home-card-middle">
            <div
              class="new-home-middle-img"
              :style="{ backgroundImage: 'url(' + middleImg + ')' }"
            ></div>
            <div
              class="new-home-middle-text"
              @click="goPage('https://www.csibizinfo.com/')"
            >
              CSI, a data-driven research and IT firm, specializes in credit,
              risk, and big data. It offers digital tools to global investors
              and business professionals, leveraging advanced analytics and
              algorithms to provide fast, visual insights that facilitate
              smarter decision-making.
            </div>
          </div>
          <div class="new-home-card-right">
            <div class="new-home-right-img">
              <img :src="wechatImg" />
            </div>
            <div class="new-home-right-text">
              To quickly search, view, and obtain company information, you can
              also use the CSI App on your phone.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/views/newLayout/header.vue";
import SearchCon from "@/views/newLayout/searchCon.vue";
export default {
  components: { Header, SearchCon },
  data() {
    return {
      offest: 38,
      carouselList: [
        {
          img: require("@/assets/images/0-1home.jpg"),
        },
        {
          img: require("@/assets/images/0-3home.jpg"),
        },
        {
          img: require("@/assets/images/chuan.png"),
        },
        {
          img: require("@/assets/images/0-5home.jpg"),
        },
        {
          img: require("@/assets/images/0-4home.jpg"),
        },
      ],
      ellipseImg: require("@/assets/images/newPage/ellipse.png"),
      middleImg: require("@/assets/images/newPage/home-center.jpg"),
      wechatImg: require("@/assets/images/newPage/wechat.png"),
      initIndex: 3,
      textList: [
        {
          title: "Business Intelligence",
        },
        {
          title: "Company Identity Verification",
        },
        {
          title: "KYC Solutions",
        },
        {
          title: "Company Financial Analysis",
        },
        {
          title: "Credit Ratings",
        },
        {
          title: "Credit Reports",
        },
        {
          title: "ESG Ratings",
        },
        {
          title: "Vendor Screening",
        },
        {
          title: "Market Research",
        },
        {
          title: "Industry Analysis",
        },
        {
          title: "Business Analytics",
        },
        {
          title: "Import-Export Data",
        },
        {
          title: "Company News",
        },
        {
          title: "Sanctions",
        },
        {
          title: "Search Leads",
        },
        {
          title: "Business Intelligence",
        },
        {
          title: "Company Identity Verification",
        },
        {
          title: "KYC Solutions",
        },
        {
          title: "Company Financial Analysis",
        },
        {
          title: "Credit Ratings",
        },
        {
          title: "Credit Reports",
        },
        {
          title: "ESG Ratings",
        },
        {
          title: "Vendor Screening",
        },
        {
          title: "Market Research",
        },
        {
          title: "Industry Analysis",
        },
        {
          title: "Business Analytics",
        },
        {
          title: "Import-Export Data",
        },
        {
          title: "Company News",
        },
        {
          title: "Sanctions",
        },
        {
          title: "Search Leads",
        },
      ],
    };
  },
  methods: {
    goPage(value) {
      window.open(value, "_blank");
    },
    scrollInit() {
      if (document.body.clientWidth >= 1510) {
        this.offest = 38;
      } else {
        this.offest = 22;
      }
      const body = document.querySelector(".slider-box");
      if (body) {
        const bodyRect = body.getBoundingClientRect();

        const bodyCenterY = bodyRect.top + bodyRect.height / 2;
        document.querySelectorAll(".slider-item").forEach((li) => {
          const liRect = li.getBoundingClientRect();
          const liCenterY = liRect.top + liRect.height / 2 + this.offest;

          if (Math.abs(bodyCenterY - liCenterY) < liRect.height / 2) {
            li.classList.add("active");
          } else {
            li.classList.remove("active");
          }
        });
      }
    },
  },
  mounted() {
    console.log(this.$route);
    
    setInterval(this.scrollInit, 100);
  },
  beforeDestroy() {
    clearInterval(this.scrollInit);
  },
};
</script>
<style scoped>
.new-home-con {
  flex: 1;
  position: relative;
}
.new-home-con .el-carousel {
  height: 100%;
}
.new-home-con >>> .el-carousel__container {
  height: 100%;
}
.new-home-con >>> .el-carousel__item {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.new-home-con >>> .el-carousel__indicators--horizontal {
  display: flex;
  align-items: center;
  height: 8px;
  bottom: 3%;
}

.new-home-con >>> .el-carousel__indicator {
  padding: 0;
}
.new-home-con >>> .el-carousel__indicator:not(:last-child) {
  margin-right: 6px;
}
.new-home-con >>> .el-carousel__button {
  width: 8px;
  height: 8px;
  opacity: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.51);
}
.new-home-con >>> .el-carousel__indicator.is-active .el-carousel__button {
  background: rgba(255, 255, 255, 1);
}
.new-home-con .new-home-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 7vh);
  z-index: 2;
}
.new-home-search {
  width: 1000px;
  height: auto;
  margin: 156px auto 0 auto;
}

.new-home-search-text {
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  text-align: center;
}
.new-home-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 82.709%;
}
.new-home-title {
  width: calc(100% - 40px);
  height: 88px;
  margin: 0 auto;
  line-height: 88px;
  padding-left: 20px;
  font-weight: 400;
  font-size: 34px;
  color: #ffffff;
  text-shadow: 0px 2px 2px rgba(6, 59, 64, 0.5);
  background: rgba(105, 128, 146, 0.45);
  border-radius: 6px;
  backdrop-filter: blur(8px);
}
.new-home-bottom-card {
  display: flex;
  height: 352px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
}
.new-home-card-left,
.new-home-card-middle {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}
.new-home-card-left {
  position: relative;
  padding-left: 50px;
  background: #1290c9;
}
.new-home-card-left img {
  position: absolute;
  top: 110px;
  left: 14px;
  width: 22px;
  height: 16px;
}
.new-home-card-left .slider-box {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.new-home-card-left .slider-con {
  display: flex;
  flex-direction: column; /* 内容排列为竖直方向 */
  padding-top: 14px;
  animation: scrollTop 15s linear infinite;
  will-change: transform;
}
@keyframes scrollTop {
  0% {
    transform: translateY(0); /* 初始位置 */
  }
  100% {
    transform: translateY(-47%);
  }
}
.new-home-card-left .slider-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  font-weight: bold;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
  transition: 0.5s ease-in-out !important;
  cursor: pointer;
}
.new-home-card-left .slider-item.active {
  font-size: 24px;
  color: #ffffff;
}
.new-home-card-left .slider-item:not(:last-child) {
  margin-bottom: 2px;
}

.new-home-card-middle {
  position: relative;
  margin: 0 14px;
  background-position: left center;
  background-size: cover;
  overflow: hidden;
}
.new-home-middle-img {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate3d(-42%, 0%, 0);
  max-width: none;
  width: 703px;
  height: 399px;
  background-position: center center;
  background-size: cover;
  /* will-change: transform; */
  animation: scrollImg 12s linear infinite alternate;
}
@keyframes scrollImg {
  0% {
    transform: translate3d(-42%, 0%, 0);
  }
  50% {
    transform: translate3d(-50%, 0%, 0);
  }
  100% {
    transform: translate3d(-58%, 0%, 0);
  }
}
.new-home-middle-text {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px 20px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  text-align: justify;
  cursor: pointer;
}
.new-home-middle-text:hover {
  text-decoration: underline;
}
.new-home-card-right {
  width: 300px;
  padding: 40px 10px 0 10px;
  background: #f5f5f5;
  border-radius: 12px;
}
.new-home-right-img {
  width: 120px;
  height: 120px;
  padding: 3px;
  margin: 0 auto 16px auto;
  background: #ffffff;
}
.new-home-right-text {
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
}
@media (max-width: 1440px) {
  .new-home-search {
    width: 666px;
    margin: 150px auto 0 auto;
  }
  .new-home-search-text {
    font-size: 14px;
    line-height: 20px;
  }
  .new-home-bottom {
    width: 1060px;
  }
  .new-home-title {
    width: calc(100% - 26px);
    height: 58px;
    line-height: 58px;
    padding-left: 14px;
    font-size: 22px;
    border-radius: 5px;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
  }
  .new-home-bottom-card {
    height: 235px;
    padding: 14px;
    border-radius: 8px;
  }
  .new-home-card-left {
    padding-left: 35px;
  }
  .new-home-card-left img {
    top: 74px;
    left: 10px;
    width: 15px;
    height: auto;
  }
  .new-home-card-left .slider-con {
    padding-top: 10px;
    animation: scrollTop 18s linear infinite;
  }
  .new-home-card-left .slider-item {
    height: 18px;
    line-height: 18px;
    font-size: 12px;
    transition: 0.4s ease-in-out !important;
  }
  .new-home-card-left .slider-item.active {
    font-size: 16px;
  }
  .new-home-card-left .slider-item:not(:last-child) {
    margin-bottom: 1px;
  }
  .new-home-card-middle {
    margin: 0 10px;
  }
  .new-home-middle-img {
    width: 468px;
    height: 266px;
    animation: scrollImg 15s linear infinite alternate;
  }
  .new-home-middle-text {
    padding: 20px 14px;
    font-size: 12px;
    line-height: 14px;
  }
  .new-home-card-right {
    width: 205px;
    padding: 26px 6px 0 6px;
    border-radius: 8px;
  }
  .new-home-right-img {
    width: 80px;
    height: 80px;
    padding: 2px;
    margin: 0 auto 10px auto;
  }
  .new-home-right-text {
    font-size: 12px;
    line-height: 14px;
  }
}




.u070db_3 {
  background: url("../../assets/images/0-1home.jpg") no-repeat;
 
}

.u070db_4 {
  background: url("../../assets/images/0-4Risk.jpg") no-repeat;
}

.u070db_5 {
  background: url("../../assets/images/0-4home.jpg") no-repeat;
}
.NewsBack{
  background-color: #3EBB72 !important;

}
.RiskBack{
    background-color: #F9722C !important;
}
</style>
